// TokenModal.js

import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button, MenuItem } from '@mui/material';
import Swal from 'sweetalert2';
import api from '../services/api';

const TokenModal = ({ open, onClose, token, onSave, fetchData }) => {
  const [tk, setTk] = useState('');
  const [origin, setOrigin] = useState('');
  const [type, setType] = useState('');

  useEffect(() => {
    if (token) {
      setTk(token.tk);
      setOrigin(token.origin);
      setType(token.type);
    } else {
      setTk('');
      setOrigin('');
      setType('');
    }
  }, [token]);

  const handleSave = async () => {
    try {
      const newToken = { tk, origin, type };

      if (token && token.id) {
        // Update existing token
        await api.put(`/tk_credenci/update-tk-credenci/${token.id}`, { tk: newToken.tk });
        await api.put(`/tk_credenci/update-origin-credenci/${token.id}`, { origin: newToken.origin });
        await api.put(`/tk_credenci/update-type-credenci/${token.id}`, { type: newToken.type });
      } else {
        await api.post('/tk_credenci/create-tk-credenci', newToken);
      }

      onSave();
      onClose();
      Swal.fire('Sucesso!', 'Token salvo com sucesso.', 'success');
      fetchData();
    } catch (error) {
      console.error("Erro ao salvar o token:", error); // Log detalhado no console
      Swal.fire('Erro!', 'Falha ao salvar o token.', 'error');
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ width: 300, padding: 2, margin: 'auto', marginTop: '10%', bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
        <Typography variant="h6" gutterBottom>{token ? 'Editar Token' : 'Adicionar Token'}</Typography>
        <TextField
          label="Token"
          value={tk}
          onChange={(e) => setTk(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Descrição"
          value={origin}
          onChange={(e) => setOrigin(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          select
          label="Tipo"
          value={type}
          onChange={(e) => setType(e.target.value)}
          fullWidth
          margin="normal"
        >
          <MenuItem value="dev">Desenvolvedor</MenuItem>
          <MenuItem value="homolog">Homologação</MenuItem>
          <MenuItem value="prod">Produção</MenuItem>
        </TextField>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
          <Button onClick={onClose}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained">Salvar</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TokenModal;
